import React, { useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import { Link } from 'react-router-dom';
import NotificationCard from './NotificationCard';
export default function NotificationsPage() {
  const { token } = useAuth();
  const [notifications, setNotifications] = useState([]);
const [userProfiles, setUserProfiles] = useState({});
 useEffect(() => {
  fetch("/notifications/me", {
    headers: { Authorization: `Bearer ${token}` }
  })
    .then(res => res.json())
    .then(data => {
      if (Array.isArray(data)) {
        setNotifications(data);
      } else {
        console.warn("❗ Donnée inattendue pour /notifications/me :", data);
        setNotifications([]); // fallback vide
      }
    })
    .catch(err => {
      console.error("❌ Erreur chargement notifications :", err);
      setNotifications([]);
    });
}, [token]);
useEffect(() => {
  fetch("/users", {
    headers: { Authorization: `Bearer ${token}` }
  })
    .then(res => res.json())
    .then(data => {
      const map = {};
      data.forEach(u => map[u.username] = u);
      setUserProfiles(map);
    });
}, [token]);

const fetchNotifications = async () => {
  try {
    const res = await fetch("/notifications/me", {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) throw new Error(`Erreur HTTP ${res.status}`);
    const data = await res.json();
    setNotifications(data);
  } catch (err) {
    console.error("❌ Erreur chargement notifications :", err);
  }
};
useEffect(() => {
  if (token) {
    fetchNotifications();
  }
}, [token]);
const handleDecision = async (notif, decision, reason = '') => {
  try {
    const res = await fetch(`/projects/${notif.project_id}/access-decision`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        user_id: notif.user_id,
        decision,
        reason,
        notif_id: notif.id
      })
    });

    if (!res.ok) {
      const errorText = await res.text(); 
      throw new Error(`Erreur ${res.status} : ${errorText}`);
    }

    const data = await res.json();
    console.log('✅ Décision enregistrée :', data);
    fetchNotifications();

    // Met à jour l’état local ou recharge les notifications
    fetchNotifications();
  } catch (err) {
    console.error("❌ Erreur lors de la décision :", err);
    alert("Une erreur est survenue : " + err.message);
  }
};



return (
  <div className="container mt-5" style={{ paddingTop: '70px' }}>
    <h2 className="mb-4">🔔 Centre de notifications</h2>

    <div className="d-flex justify-content-between align-items-center mb-4">
      <p className="text-muted">Vous avez {notifications.length} notification(s)</p>
      <Link to="/admin/access-log" className="btn btn-outline-dark btn-sm">
        📜 Voir l’historique des décisions
      </Link>
    </div>

    <div className="row g-3">
     {notifications.map(notif => (
  <NotificationCard
    key={notif.id}
    notif={notif}
    user={userProfiles[notif.user_id]}
    onDecision={handleDecision}
  />
))}
    </div>
  </div>
);


}
